<div style="width: 260px; height: 100%;">
    <app-modelo-select (passArray)="selectModelos($event)"></app-modelo-select>
    <jqxGrid #grid [theme]=" theme" style="margin-top: 0px;" [width]="'100%'" [height]="'93%'" [source]="dataAdapter"
        [columnsresize]="true" [filterable]="true" [showfilterrow]="false" [filtermode]="'excel'"
        [selectionmode]="'checkbox'" [columns]="columns" [sortable]="true" [altrows]="true" [showrowlines]="false"
        [filterrowheight]="30" [rowsheight]="25" [columnsheight]="20" [enabletooltips]="true" [showaggregates]="true"
        [showstatusbar]="true" [showtoolbar]="true" [statusbarheight]="20" [toolbarheight]="32"
        (onRowunselect)="onUnselect($event)" [localization]="langGrid" [rendertoolbar]="createToolBar"
        (onRowselect)="onSelect($event)">
    </jqxGrid>
</div>